import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/icons/sprite.svg'


const _hoisted_1 = _imports_0 + '#caretUp'
const _hoisted_2 = { class: "catalog-item__left" }
const _hoisted_3 = { class: "catalog-item__icon" }
const _hoisted_4 = {
  width: "20",
  height: "20"
}
const _hoisted_5 = ["xlink:href"]

import { computed } from "vue";
  import sprite from "@/assets/icons/sprite.svg";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'CatalogMenuItem',
  props: ["data"],
  setup(__props) {

  const props = __props;
 
  const iconPath = computed(() => `${sprite}#${props.data.ufIcon}`);


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: `/catalog-menu/${__props.data.id}`,
    class: "catalog-item"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_openBlock(), _createElementBlock("svg", _hoisted_4, [
            _createElementVNode("use", { "xlink:href": iconPath.value }, null, 8, _hoisted_5)
          ]))
        ]),
        _createTextVNode(" " + _toDisplayString(__props.data.name), 1)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("svg", {
        width: "20",
        height: "20"
      }, [
        _createElementVNode("use", { "xlink:href": _hoisted_1 })
      ], -1))
    ]),
    _: 1
  }, 8, ["to"]))
}
}

})